/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ng2-nouislider/src/nouislider';
import * as import2 from '@angular/forms';
class NouisliderModuleInjector extends import0.ɵNgModuleInjector<import1.NouisliderModule> {
  _NouisliderModule_0:import1.NouisliderModule;
  constructor(parent:import0.Injector) {
    super(parent,([] as any[]),([] as any[]));
  }
  createInternal():import1.NouisliderModule {
    this._NouisliderModule_0 = new import1.NouisliderModule();
    return this._NouisliderModule_0;
  }
  getInternal(token:any,notFoundResult:any):any {
    if ((token === import1.NouisliderModule)) { return this._NouisliderModule_0; }
    return notFoundResult;
  }
  destroyInternal():void {
  }
}
export const NouisliderModuleNgFactory:import0.NgModuleFactory<import1.NouisliderModule> = new import0.NgModuleFactory<any>(NouisliderModuleInjector,import1.NouisliderModule);
const styles_NouisliderComponent:any[] = ['[_nghost-%COMP%] {\n      display: block;\n      margin-top: 1rem;\n      margin-bottom: 1rem;\n    }'];
export const RenderType_NouisliderComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 0,
  styles: styles_NouisliderComponent,
  data: {}
}
);
export function View_NouisliderComponent_0(l:any):import0.ɵViewDefinition {
      return import0.ɵvid(0,[(l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',([] as any[]),[[
        1,
        'disabled',
        0
      ]
  ],(null as any),(null as any),(null as any),(null as any)))],(null as any),(ck,v) => {
    var co:import1.NouisliderComponent = v.component;
    const currVal_0:any = (co.disabled? true: (undefined as any));
    ck(v,0,0,currVal_0);
  });
}
function View_NouisliderComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'nouislider',([] as any[]),[[
        2,
        'ng2-nouislider',
        (null as any)
      ]
    ],(null as any),(null as any),View_NouisliderComponent_0,RenderType_NouisliderComponent)),
    import0.ɵdid(638976,(null as any),0,import1.NouisliderComponent,[import0.ElementRef],(null as any),(null as any)),
    import0.ɵprd(5120,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import1.NouisliderComponent])
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(ck,v) => {
    const currVal_0:any = true;
    ck(v,0,0,currVal_0);
  });
}
export const NouisliderComponentNgFactory:import0.ComponentFactory<import1.NouisliderComponent> = import0.ɵccf('nouislider',import1.NouisliderComponent,View_NouisliderComponent_Host_0,{
  disabled: 'disabled',
  behaviour: 'behaviour',
  connect: 'connect',
  limit: 'limit',
  min: 'min',
  max: 'max',
  step: 'step',
  format: 'format',
  pageSteps: 'pageSteps',
  config: 'config',
  ngModel: 'ngModel',
  keyboard: 'keyboard',
  onKeydown: 'onKeydown',
  formControl: 'formControl',
  tooltips: 'tooltips'
}
,{
  change: 'change',
  update: 'update',
  slide: 'slide',
  set: 'set',
  start: 'start',
  end: 'end'
}
,([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9idWlsZC9ob3dtdWNoL25vZGVfbW9kdWxlcy9uZzItbm91aXNsaWRlci9zcmMvbm91aXNsaWRlci5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvYnVpbGQvaG93bXVjaC9ub2RlX21vZHVsZXMvbmcyLW5vdWlzbGlkZXIvc3JjL25vdWlzbGlkZXIuZC50cyIsIm5nOi8vL3Zhci9idWlsZC9ob3dtdWNoL25vZGVfbW9kdWxlcy9uZzItbm91aXNsaWRlci9zcmMvbm91aXNsaWRlci5kLnRzLk5vdWlzbGlkZXJDb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci9idWlsZC9ob3dtdWNoL25vZGVfbW9kdWxlcy9uZzItbm91aXNsaWRlci9zcmMvbm91aXNsaWRlci5kLnRzLk5vdWlzbGlkZXJDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IFthdHRyLmRpc2FibGVkXT1cImRpc2FibGVkID8gdHJ1ZSA6IHVuZGVmaW5lZFwiPjwvZGl2PiIsIjxub3Vpc2xpZGVyPjwvbm91aXNsaWRlcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7NkJDQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTtFQUFBOztJQUFLO0lBQUwsU0FBSyxTQUFMOzs7OztNQ0FBO1FBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBQTtnQkFBQTtNQUFBO0lBQUE7OztJQUFBOztJQUFBO0lBQUEsU0FBQSxTQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/ngfactory/~/ng2-nouislider/src/nouislider.ngfactory.ts